export default __webpack_public_path__ + "static/media/facebookDeskFill.dba3b714.svg";